import { Zodios, type ZodiosBodyByAlias, type ZodiosInstance } from "@zodios/core";

import { api } from "@skilitics/distribution-delivery-http-api";

import { getRequiredAppSetting } from "../shared/index.ts";
import { attachAuthorizationMiddleware } from "./infrastructure/index.ts";

const endpoint = getRequiredAppSetting(
  import.meta.env.REACT_APP_DISTRIBUTION_DELIVERY_ENDPOINT,
  "DISTRIBUTION_DELIVERY_ENDPOINT",
);

const apiClient = new Zodios(endpoint, api);
attachAuthorizationMiddleware(apiClient.axios);

export const useDistributionDeliveryApiClient = (): ZodiosInstance<typeof api> => {
  return apiClient;
};

export type DeliveryPayload = ZodiosBodyByAlias<typeof api, "deliver">;
export type DeliverySettings = DeliveryPayload["settings"];
